import { render, staticRenderFns } from "./linkNav.vue?vue&type=template&id=4d768c8d&scoped=true"
import script from "./linkNav.vue?vue&type=script&lang=js"
export * from "./linkNav.vue?vue&type=script&lang=js"
import style0 from "./linkNav.vue?vue&type=style&index=0&id=4d768c8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d768c8d",
  null
  
)

export default component.exports